import { InputNumber, type InputNumberProps } from '@arco-design/web-react';

/**
 * MoneyInput
 * --------------------------------
 * 标准化金额输入框：始终以「美元」作为前端展示单位，强制保留两位小数精度。
 * 业务侧负责在提交 API 前将本组件值乘以 100 转换为美分整数（详见 src/utils/money.ts）。
 *
 * 设计规范:
 *   - 输入精度统一为 2
 *   - 默认 step=1，最小 0
 *   - 始终展示美元 $ 前缀，避免与 RMB ¥ 混淆
 */
export interface MoneyInputProps
  extends Omit<InputNumberProps, 'precision' | 'min' | 'prefix'> {
  /** 当前美元值（小数点保留两位） */
  value?: number;
  /** 自定义最小值，默认 0 */
  minDollar?: number;
}

export function MoneyInput({ minDollar = 0, ...rest }: MoneyInputProps) {
  return (
    <InputNumber
      precision={2}
      step={1}
      min={minDollar}
      prefix="$"
      placeholder="请输入美元金额"
      style={{ width: '100%' }}
      {...rest}
    />
  );
}
